import React, { Fragment, useState } from 'react';
import Button from '~/UI/Button';
import buttonPrimaryWideStyles from '~/UI/Button/primary-wide.less';
import Heading from '~/UI/Heading/Heading';

import styles from './styles.less';
import Checkbox from '~/UI/Checkbox/Checkbox';
import { postGdprConsent } from '~/infrastructure/api/user/gdprConsent';
import { useLocation, useHistory } from 'react-router-dom';
import { FlashMessages } from '~/FlashMessage';
import { useSelector } from 'react-redux';
import { ApplicationState } from '~/Store';

export const GdprPage: React.FunctionComponent = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [gdprConsent, setGdprConsent] = useState(false);
	const [showGdprConsentWarning, setShowGdprConsentWarning] = useState(true);
	const [directMarketingConsent, setDirectMarketingConsent] = useState(true);
	const location = useLocation();
	const history = useHistory();
	const currentToken = useSelector(({ accessToken }: ApplicationState) => accessToken.accessToken);

	React.useEffect(() => {
		if (currentToken && currentToken.impersonatedBy != null) {
			history.push('/');
		}
	}, [currentToken]);

	const handleGdprConsent = (value: boolean) => {
		if (value) {
			setShowGdprConsentWarning(false);
		} else {
			setShowGdprConsentWarning(true);
		}

		setGdprConsent(value);
	};

	const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		if (!gdprConsent) {
			return;
		}

		setLoading(true);

		postGdprConsent({ termsConsent: gdprConsent, marketingConsent: directMarketingConsent })
			.then(() => {
				//this `state` and `originalLocation` in it is set in `src/Login/actions.ts`
				// @ts-expect-error dynamically added
				if (location.state?.originalLocation) {
					// @ts-expect-error dynamically added
					history.push(location.state.originalLocation.pathname);
				} else {
					history.push('/');
				}
			})
			.catch(() => {
				setError(true);
			});

		setLoading(false);
	};

	return (
		<Fragment>
			<section className={styles.section}>
				<div className={styles.in}>
					<form data-testid='login-form' onSubmit={handleFormSubmit}>
						<div className={styles.form}>
							<Heading>GDPR</Heading>

							<div className={styles.consent}>
								<div className={styles.consentCheckbox}>
									<Checkbox checked={gdprConsent} onChange={handleGdprConsent} />
								</div>
								<div>
									<div className={styles.consentHeading}>
										Consent to the terms of the user account and information on processing personal data.
									</div>
									<div className={styles.consentText}>
										By checking the box, I agree to the terms of the user account and acknowledge the information on
										processing personal data for registration, all of which is available{' '}
										<a href={'https://www.cogvio.com/terms/'}>here</a>.
									</div>
								</div>
							</div>

							<div className={styles.consent}>
								<div className={styles.consentCheckbox}>
									<Checkbox checked={directMarketingConsent} onChange={setDirectMarketingConsent} />
								</div>
								<div>
									<div className={styles.consentHeading}>Consent to direct marketing.</div>
									<div className={styles.consentText}>
										As our customer, you will receive electronic commercial communications under the conditions
										specified <a href={'https://www.cogvio.com/terms/'}>here</a>. This consent can be refused at any
										time.
									</div>
								</div>
							</div>

							{showGdprConsentWarning && (
								<div>
									<p className={styles.consentWarning}>
										If you do not wish to grant Consent to the terms of the user account and information on processing
										personal data, please contact us at <a href={`mailto:support@cogvio.com`}>support@cogvio.com</a>.
									</p>
								</div>
							)}

							<Button styles={buttonPrimaryWideStyles} disabled={!gdprConsent || loading}>
								Submit
							</Button>
						</div>
					</form>
				</div>
			</section>
			{error && (
				<FlashMessages
					messages={[
						{
							key: -1,
							type: 'error',
							text: 'Something went wrong, please refresh the page.',
							dismissable: false,
						},
					]}
				/>
			)}
		</Fragment>
	);
};
